import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="container-x">
      <ol className="flex flex-wrap items-center gap-1.5 py-4 text-sm text-foreground-600">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 transition-colors hover:text-primary-600 cursor-pointer">
            <i className="ri-home-5-line" aria-hidden="true" />
            首页
          </Link>
        </li>
        {items.map((c) => (
          <li key={c.label} className="inline-flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
            {c.to ? (
              <Link to={c.to} className="transition-colors hover:text-primary-600 cursor-pointer">
                {c.label}
              </Link>
            ) : (
              <span className="font-label text-foreground-950">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}